/* ==========================================================================
   DIDO — ATELIER  ·  Theme JS
   Lightweight, dependency-free.
   ========================================================================== */
(function () {
  'use strict';

  const money = (cents) =>
    (window.DIDO && window.DIDO.moneyFormat ? window.DIDO.moneyFormat : '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString());

  /* ---------- Reveal on scroll ---------- */
  document.documentElement.classList.add('reveal-on');
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    revealEls.forEach((el) => io.observe(el));
    /* safety net: never leave content hidden */
    setTimeout(() => revealEls.forEach((el) => el.classList.add('is-in')), 2600);
  } else {
    revealEls.forEach((el) => el.classList.add('is-in'));
  }

  /* Theme editor: when a section is re-rendered, reveal its content immediately
     (otherwise freshly-injected [data-reveal] elements stay invisible) and
     re-run any per-section init so it never looks "broken" while editing. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    e.target.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      if (old.src) { s.src = old.src; } else { s.textContent = old.textContent; }
      old.parentNode.replaceChild(s, old);
    });
  });
  document.addEventListener('shopify:section:select', function (e) {
    e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  });

  /* ---------- Header hide on scroll ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > last && y > 240) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      last = y;
    }, { passive: true });
  }

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    const d = document.getElementById(id);
    const ov = document.querySelector('[data-drawer-overlay]');
    if (!d) return;
    d.classList.add('is-open');
    if (ov) ov.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    d.setAttribute('aria-hidden', 'false');
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    const ov = document.querySelector('[data-drawer-overlay]');
    if (ov) ov.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-drawer-overlay]')) closeDrawers();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart helpers ---------- */
  async function getCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }
  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }
  async function refreshCartDrawer() {
    try {
      const res = await fetch('/?section_id=cart-drawer');
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const fresh = html.querySelector('[data-cart-drawer-contents]');
      const current = document.querySelector('[data-cart-drawer-contents]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    } catch (err) { /* noop */ }
    const cart = await getCart();
    updateCartCount(cart);
  }

  /* ---------- Add to cart (forms + quick add) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn && btn.hasAttribute('data-needs-choice')) return;
    const original = btn ? btn.innerHTML : '';
    if (btn) { btn.classList.add('is-loading'); btn.innerHTML = 'Adding…'; btn.disabled = true; }
    try {
      const data = new FormData(form);
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data });
      if (!r.ok) throw new Error('add failed');
      await refreshCartDrawer();
      openDrawer('cart-drawer');
    } catch (err) {
      form.submit();
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.innerHTML = original; btn.disabled = false; }
    }
  });

  /* ---------- Cart quantity (drawer + cart page) ---------- */
  async function changeLine(line, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    const cart = await r.json();
    updateCartCount(cart);
    await refreshCartDrawer();
    if (document.querySelector('[data-cart-page]')) window.location.reload();
    return cart;
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-qty-change]');
    if (!q) return;
    const wrap = q.closest('[data-line]');
    if (!wrap) return;
    const line = parseInt(wrap.getAttribute('data-line'), 10);
    const input = wrap.querySelector('input');
    let val = parseInt(input.value, 10) + parseInt(q.getAttribute('data-qty-change'), 10);
    if (val < 0) val = 0;
    input.value = val;
    changeLine(line, val);
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    const wrap = rm.closest('[data-line]');
    changeLine(parseInt(wrap.getAttribute('data-line'), 10), 0);
  });

  /* ---------- Product page: variant selection ----------
     Audit H7 (9 Oct 2026): no size is preselected (the button says "Select a size" until one is chosen);
     sizes and colours that can't be bought with the current choice are crossed out and announced as
     "sold out" to screen readers; changing colour switches the main photo to that colour. */
  document.querySelectorAll('[data-variant-root]').forEach((root) => {
    const jsonEl = root.querySelector('[data-variant-json]');
    if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const priceEl = root.querySelector('[data-variant-price]');
    const compareEl = root.querySelector('[data-variant-compare]');
    const idInput = root.querySelector('[data-variant-id]');
    const addBtn = root.querySelector('[data-add-btn]');
    const groups = Array.from(root.querySelectorAll('[data-option-index]'));
    const anyAvailable = data.some((v) => v.available);
    const mainImg = root.querySelector('[data-gallery-main] img');

    function currentOptions() {
      return groups.map((g) => {
        const checked = g.querySelector('input:checked') || g.querySelector('select');
        return checked ? checked.value : null;
      });
    }
    /* Does variant v agree with every chosen option (ignoring option `skip` and options not chosen yet)? */
    function fits(v, opts, skip) {
      return v.options.every((o, j) => j === skip || opts[j] == null || o === opts[j]);
    }
    function markAvailability(opts) {
      groups.forEach((g, i) => {
        g.querySelectorAll('input[type="radio"]').forEach((inp) => {
          const label = inp.id ? root.querySelector('label[for="' + CSS.escape(inp.id) + '"]') : null;
          if (!label) return;
          const ok = !anyAvailable || data.some((v) => v.available && v.options[i] === inp.value && fits(v, opts, i));
          label.classList.toggle('is-unavailable', !ok);
          let sr = label.querySelector('.pdp__pill-sr');
          if (!ok && !sr) {
            sr = document.createElement('span');
            sr.className = 'visually-hidden pdp__pill-sr';
            sr.textContent = ' – sold out';
            label.appendChild(sr);
          } else if (ok && sr) {
            sr.remove();
          }
        });
      });
    }
    function setAddText(text) {
      const t = addBtn && addBtn.querySelector('[data-add-text]');
      if (t) t.textContent = text;
    }
    function update() {
      const opts = currentOptions();
      markAvailability(opts);
      root.querySelectorAll('[data-selected-value]').forEach((el) => {
        el.textContent = opts[parseInt(el.getAttribute('data-selected-value'), 10)] || '';
      });
      const missing = opts.findIndex((o) => o == null);
      if (missing > -1) {
        if (idInput) idInput.value = '';
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.setAttribute('data-needs-choice', '1');
          setAddText('Select a ' + (groups[missing].getAttribute('data-option-name') || 'option').toLowerCase());
        }
        return;
      }
      const match = data.find((v) => v.options.every((o, i) => o === opts[i]));
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price;
      if (compareEl) compareEl.innerHTML = match.compare || '';
      if (addBtn) {
        addBtn.removeAttribute('data-needs-choice');
        addBtn.disabled = !match.available;
        setAddText(match.available ? addBtn.getAttribute('data-add-label') : 'Sold out');
      }
    }
    function showImage(opts) {
      if (!mainImg) return;
      const v = data.find((x) => x.image && fits(x, opts, -1));
      if (!v || mainImg.getAttribute('src') === v.image) return;
      mainImg.src = v.image;
      mainImg.srcset = '';
      if (v.alt) mainImg.alt = v.alt;
      root.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', t.getAttribute('data-full') === v.image));
    }
    root.addEventListener('change', (e) => {
      const g = e.target.closest('[data-option-index]');
      if (!g) return;
      update();
      if (!g.hasAttribute('data-size-option')) showImage(currentOptions());
    });
    update();
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-thumb]').forEach((t) => {
      t.addEventListener('click', () => {
        if (!main) return;
        main.src = t.getAttribute('data-full');
        main.srcset = '';
        g.querySelectorAll('[data-thumb]').forEach((x) => x.classList.remove('is-active'));
        t.classList.add('is-active');
      });
    });
  });

  /* ---------- Init cart count ---------- */
  getCart().then(updateCartCount).catch(() => {});
  window.DIDO = window.DIDO || {};
  window.DIDO.refreshCart = refreshCartDrawer;
})();
